//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

import IconLink from 'components/Shared/IconLink/Index'
import ModalNotification from 'components/Shared/Notification/ModalNotification'
import EnvironmentStripe from 'components/App/NavBar/EnvironmentStripe'

const StyledModalHeader = styled.div`
  margin: 32px 32px 24px 32px;
  display: flex;
  position: relative;
`

const StyledModalHeaderTitle = styled.div`
  font-family: Exo;
  font-size: 40px;
  font-weight: 300;
  line-height: 40px;
  margin-right: 8px;

  & > * {
    margin-left: 20px;
  }
`

const StyledCloseButton = styled(IconLink)`
  position: absolute;
  right: -14px;
  top: -8px;

  &:before {
    color: ${colors.secondary70};
  }
`

const NotificationWrapper = styled.div`
  position: absolute;
  width: auto;
  left: -32px;
  right: -32px;
  bottom: ${props => props.withTabs ? '-67' : '-24'}px;
  z-index: 1;
`

const StyledEnvironmentStripe = styled(EnvironmentStripe)`
  width: auto;
  left: -32px;
  right: -32px;
  top: -26px;
`

const ModalHeader = ({ children, closeModal, withNotification, withTabs }) => {
  return (
    <StyledModalHeader>
      <StyledEnvironmentStripe />
      <StyledModalHeaderTitle data-test='modal-header'>
        {children}
      </StyledModalHeaderTitle>
      {withNotification && (
        <NotificationWrapper withTabs={withTabs}>
          <ModalNotification />
        </NotificationWrapper>
      )}
      {closeModal && <StyledCloseButton iconName='icon-close-12' onClick={closeModal} />}
    </StyledModalHeader>
  )
}

ModalHeader.propTypes = {
  children: PropTypes.node,
  closeModal: PropTypes.func,
  withNotification: PropTypes.bool,
  withTabs: PropTypes.bool,
}

export default ModalHeader
